"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
require("../dto/accommodation-preferences-save-dto");
const accommodation_preferences_service_1 = require("../../services/accommodation-preferences.service");
const current_accommodation_preferences_dto_1 = require("../dto/current-accommodation-preferences-dto");
const dnaRSnackBar_service_1 = require("../../../common/dna-r/dnaRSnackBar.service");
const rxjs_1 = require("rxjs");
const i0 = require("@angular/core");
const i1 = require("../../services/accommodation-preferences.service");
const i2 = require("../../../common/dna-r/dnaRSnackBar.service");
const i3 = require("@angular/common");
const i4 = require("@angular/forms");
const i5 = require("../../../common/components/dnaR-dropdown-multiSelect/dnaR-dropdown-multiSelect.component");
function AccommodationPreferencesComponent_a_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵlistener("click", function AccommodationPreferencesComponent_a_7_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.addClick(); });
    i0.ɵɵtext(1, "Add");
    i0.ɵɵelementEnd();
} }
function AccommodationPreferencesComponent_a_8_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 10);
    i0.ɵɵlistener("click", function AccommodationPreferencesComponent_a_8_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.editClick(); });
    i0.ɵɵtext(1, "Edit");
    i0.ɵɵelementEnd();
} }
function AccommodationPreferencesComponent_div_10_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelementStart(2, "label", 29);
    i0.ɵɵtext(3, "Preferred location");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 17);
    i0.ɵɵelementStart(5, "dnaR-dropdown-multiSelect", 30);
    i0.ɵɵlistener("onSelectionChange", function AccommodationPreferencesComponent_div_10_div_2_Template_dnaR_dropdown_multiSelect_onSelectionChange_5_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(2); return ctx_r9.preferredLocationsSelectionChanged($event); });
    i0.ɵɵpipe(6, "async");
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("placeholder", "Select location/s")("settings", ctx_r8.dropdownSettings)("data", i0.ɵɵpipeBind1(6, 4, ctx_r8.LocationsList$))("initialSelectedItems", i0.ɵɵpipeBind1(7, 6, ctx_r8.SelectedPreferredLocations$));
} }
function AccommodationPreferencesComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "form", 12);
    i0.ɵɵtemplate(2, AccommodationPreferencesComponent_div_10_div_2_Template, 8, 8, "div", 13);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementStart(5, "div", 14);
    i0.ɵɵelementStart(6, "div", 15);
    i0.ɵɵelementStart(7, "label", 16);
    i0.ɵɵtext(8, "Preferred unit type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 17);
    i0.ɵɵelementStart(10, "dnaR-dropdown-multiSelect", 18);
    i0.ɵɵlistener("onSelectionChange", function AccommodationPreferencesComponent_div_10_Template_dnaR_dropdown_multiSelect_onSelectionChange_10_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.preferredUnitTypesSelectionChanged($event); });
    i0.ɵɵpipe(11, "async");
    i0.ɵɵpipe(12, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 19);
    i0.ɵɵelementStart(14, "div", 15);
    i0.ɵɵelementStart(15, "label", 20);
    i0.ɵɵtext(16, "Preferred unit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 17);
    i0.ɵɵelementStart(18, "dnaR-dropdown-multiSelect", 21);
    i0.ɵɵlistener("onSelectionChange", function AccommodationPreferencesComponent_div_10_Template_dnaR_dropdown_multiSelect_onSelectionChange_18_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.preferredUnitsSelectionChanged($event); });
    i0.ɵɵpipe(19, "async");
    i0.ɵɵpipe(20, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 22);
    i0.ɵɵelement(22, "div", 23);
    i0.ɵɵelementStart(23, "div", 24);
    i0.ɵɵelementStart(24, "button", 25);
    i0.ɵɵlistener("click", function AccommodationPreferencesComponent_div_10_Template_button_click_24_listener() { i0.ɵɵrestoreView(_r12); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.cancel(); });
    i0.ɵɵtext(25, "Cancel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 26);
    i0.ɵɵelementStart(27, "button", 27);
    i0.ɵɵlistener("click", function AccommodationPreferencesComponent_div_10_Template_button_click_27_listener() { i0.ɵɵrestoreView(_r12); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.save(); });
    i0.ɵɵtext(28, "Save");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 9, ctx_r2.LocationsList$) !== null && i0.ɵɵpipeBind1(4, 11, ctx_r2.LocationsList$).length > 0);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("placeholder", "Select unit type/s")("settings", ctx_r2.dropdownSettings)("data", i0.ɵɵpipeBind1(11, 13, ctx_r2.UnitTypesList$))("initialSelectedItems", i0.ɵɵpipeBind1(12, 15, ctx_r2.SelectedPreferredUnitTypes$));
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("placeholder", "Select unit/s")("settings", ctx_r2.unitDropdownSettings)("data", i0.ɵɵpipeBind1(19, 17, ctx_r2.UnitsList$))("initialSelectedItems", i0.ɵɵpipeBind1(20, 19, ctx_r2.SelectedPreferredUnits$));
} }
function AccommodationPreferencesComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵelement(2, "span", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 34);
    i0.ɵɵelementStart(4, "div", 35);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 36);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 37);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 3, ctx_r3.CurrentPreferredLocationsString$));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 5, ctx_r3.CurrentPreferredUnitTypesString$));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 7, ctx_r3.CurrentPreferredUnitsString$));
} }
class AccommodationPreferencesComponent {
    constructor(authenticationService, accommodationPreferencesService, snackBarService) {
        this.authenticationService = authenticationService;
        this.accommodationPreferencesService = accommodationPreferencesService;
        this.snackBarService = snackBarService;
        this.isAdd = false;
        this.isEdit = false;
        this.isExpanded = false;
        this.isReadOnly = false;
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'id',
            textField: 'name',
            itemsShowLimit: 1,
            maxHeight: 500,
            addAllOption: false,
            enableCheckAll: false
        };
        this.unitDropdownSettings = {
            singleSelection: false,
            headerField: 'header',
            idField: 'id',
            textField: 'name',
            itemsShowLimit: 1,
            maxHeight: 500,
            addAllOption: false,
            enableCheckAll: false,
            allowSearchFilter: true,
            searchPlaceholderText: 'Search...'
        };
        /* Since we are loading the below from DB then we use observable / BehaviorSubject as we need to wait for the load */
        /* Set initial value to null */
        this.LocationsList$ = new rxjs_1.BehaviorSubject(null);
        this.UnitTypesList$ = new rxjs_1.BehaviorSubject(null);
        this.UnitsList$ = new rxjs_1.BehaviorSubject(null);
        this.SelectedPreferredLocations$ = new rxjs_1.BehaviorSubject(null);
        this.SelectedPreferredUnitTypes$ = new rxjs_1.BehaviorSubject(null);
        this.SelectedPreferredUnits$ = new rxjs_1.BehaviorSubject(null);
        this.CurrentPreferredLocations$ = new rxjs_1.BehaviorSubject(null);
        this.CurrentPreferredUnitTypes$ = new rxjs_1.BehaviorSubject(null);
        this.CurrentPreferredUnits$ = new rxjs_1.BehaviorSubject(null);
        this.CurrentPreferredLocationsString$ = new rxjs_1.BehaviorSubject('');
        this.CurrentPreferredUnitTypesString$ = new rxjs_1.BehaviorSubject('');
        this.CurrentPreferredUnitsString$ = new rxjs_1.BehaviorSubject('');
        this.setIsReadOnly = () => {
            this.authenticationService.userHasPermissionDeferred((x) => {
                return x.leadsDetails.canModify;
            }).then(() => {
                this.isReadOnly = this.isReadOnlyComponent ? true : false;
            }, () => {
                this.isReadOnly = true;
            });
        };
        this.loadSelectedFacilityLocations();
        this.loadSelectedFacilityUnitTypes();
        this.loadSelectedFacilityUnits();
    }
    get model() {
        return this._model;
    }
    set model(model) {
        this._model = model;
    }
    // Called after component input evaluation
    ngOnChanges() {
        this.setIsReadOnly();
        this.getCurrentAccommodationPreferences();
    }
    loadSelectedFacilityLocations() {
        this.accommodationPreferencesService.getSelectedFacility().then((selectedFacility) => {
            this.LocationsList$.next(selectedFacility.locations);
        });
    }
    loadSelectedFacilityUnitTypes() {
        this.accommodationPreferencesService.getUnitTypesForSelectedFacility().then((result) => {
            this.UnitTypesList$.next(result);
        });
    }
    loadSelectedFacilityUnits() {
        this.accommodationPreferencesService.getUnitsForSelectedFacility().then(result => {
            this.UnitsList$.next(result);
        });
    }
    checkAddEditMode() {
        this.isAdd = false;
        this.isEdit = false;
        if (this.CurrentPreferredLocations$.value.length == 0 &&
            this.CurrentPreferredUnitTypes$.value.length == 0 &&
            this.CurrentPreferredUnits$.value.length == 0) {
            this.isAdd = true;
        }
        if (this.CurrentPreferredLocations$.value.length !== 0 ||
            this.CurrentPreferredUnitTypes$.value.length !== 0 ||
            this.CurrentPreferredUnits$.value.length !== 0) {
            this.isEdit = true;
        }
    }
    addClick() {
        this.isAdd = true;
        this.isExpanded = true;
    }
    editClick() {
        this.isEdit = true;
        this.isExpanded = true;
    }
    getCurrentAccommodationPreferences() {
        // If accommodation reference data was passed as an input
        if (this._model !== undefined && this._model !== null) {
            this.loadCurrentAccommodationPreferencesFromModel();
            this.checkAddEditMode();
        }
        else {
            this.loadCurrentAccommodationPreferencesFromDb();
        }
    }
    loadCurrentAccommodationPreferencesFromModel() {
        this.CurrentPreferredLocations$.next(this._model.currentPreferredLocations);
        this.CurrentPreferredUnitTypes$.next(this._model.currentPreferredUnitTypes);
        this.CurrentPreferredUnits$.next(this._model.currentPreferredUnits);
        this.setInitialSelectedPreferences(this._model.currentPreferredLocations, this._model.currentPreferredUnitTypes, this._model.currentPreferredUnits);
        // set view string values
        this.CurrentPreferredLocationsString$.next(this._model.currentPreferredLocations.map(x => x.value).join(", "));
        this.CurrentPreferredUnitTypesString$.next(this._model.currentPreferredUnitTypes.map(x => x.value).join(", "));
        this.CurrentPreferredUnitsString$.next(this._model.currentPreferredUnits.map(x => x.value).join(", "));
    }
    loadCurrentAccommodationPreferencesFromDb() {
        this.accommodationPreferencesService.getAccommodationPreferences(this.residencyId).then((result) => {
            this.CurrentPreferredLocations$.next(result.currentPreferredLocations);
            this.CurrentPreferredUnitTypes$.next(result.currentPreferredUnitTypes);
            this.CurrentPreferredUnits$.next(result.currentPreferredUnits);
            this.setInitialSelectedPreferences(result.currentPreferredLocations, result.currentPreferredUnitTypes, result.currentPreferredUnits);
            // set view string values
            this.CurrentPreferredLocationsString$.next(result.currentPreferredLocations.map(x => x.value).join(", "));
            this.CurrentPreferredUnitTypesString$.next(result.currentPreferredUnitTypes.map(x => x.value).join(", "));
            this.CurrentPreferredUnitsString$.next(result.currentPreferredUnits.map(x => x.value).join(", "));
            this.checkAddEditMode();
        });
    }
    setInitialSelectedPreferences(currentPreferredLocations, currentPreferredUnitTypes, currentPreferredUnits) {
        this.SelectedPreferredLocations$ = new rxjs_1.BehaviorSubject(null);
        this.SelectedPreferredUnitTypes$ = new rxjs_1.BehaviorSubject(null);
        this.SelectedPreferredUnits$ = new rxjs_1.BehaviorSubject(null);
        var selectedPreferredLocations = [];
        var selectedPreferredUnitTypes = [];
        var selectedPreferredUnits = [];
        currentPreferredLocations.forEach(currentLocation => {
            selectedPreferredLocations.push(currentLocation.key);
        });
        currentPreferredUnitTypes.forEach(currentUnitType => {
            selectedPreferredUnitTypes.push(currentUnitType.key);
        });
        currentPreferredUnits.forEach(currentUnit => {
            selectedPreferredUnits.push(currentUnit.key);
        });
        this.SelectedPreferredLocations$.next(selectedPreferredLocations);
        this.SelectedPreferredUnitTypes$.next(selectedPreferredUnitTypes);
        this.SelectedPreferredUnits$.next(selectedPreferredUnits);
    }
    save() {
        let accommodationPreferencesSaveDto = {
            ResidencyId: this.residencyId,
            SelectedPreferredLocations: this.SelectedPreferredLocations$.value,
            SelectedPreferredUnitTypes: this.SelectedPreferredUnitTypes$.value,
            SelectedPreferredUnits: this.SelectedPreferredUnits$.value
        };
        this.accommodationPreferencesService.saveAccommodationPreferences(accommodationPreferencesSaveDto).then(() => {
            this.snackBarService.success('Accommodation preferences saved');
            this.getCurrentAccommodationPreferences();
            this.isAdd = false;
            this.isEdit = true;
            this.isExpanded = false;
        }, () => {
            this.snackBarService.failure('Accommodation preferences couldn\'t be saved');
        });
    }
    cancel() {
        this.isExpanded = false;
        this.getCurrentAccommodationPreferences();
    }
    preferredLocationsSelectionChanged(selectedItems) {
        var selectedPreferredLocations = [];
        selectedItems.forEach(item => { selectedPreferredLocations.push(item.id); });
        this.SelectedPreferredLocations$.next(selectedPreferredLocations);
    }
    preferredUnitTypesSelectionChanged(selectedItems) {
        var selectedPreferredUnitTypes = [];
        selectedItems.forEach(item => { selectedPreferredUnitTypes.push(item.id); });
        this.SelectedPreferredUnitTypes$.next(selectedPreferredUnitTypes);
    }
    preferredUnitsSelectionChanged(selectedItems) {
        var selectedPreferredUnits = [];
        selectedItems.forEach(item => { selectedPreferredUnits.push(item.id); });
        this.SelectedPreferredUnits$.next(selectedPreferredUnits);
    }
}
exports.AccommodationPreferencesComponent = AccommodationPreferencesComponent;
AccommodationPreferencesComponent.ɵfac = function AccommodationPreferencesComponent_Factory(t) { return new (t || AccommodationPreferencesComponent)(i0.ɵɵdirectiveInject('authentication.service'), i0.ɵɵdirectiveInject(i1.AccommodationPreferencesService), i0.ɵɵdirectiveInject(i2.DnaRSnackBarService)); };
AccommodationPreferencesComponent.ɵcmp = i0.ɵɵdefineComponent({ type: AccommodationPreferencesComponent, selectors: [["accommodation-preferences"]], inputs: { residencyId: "residencyId", isReadOnlyComponent: "isReadOnlyComponent", model: "model" }, features: [i0.ɵɵNgOnChangesFeature], decls: 12, vars: 4, consts: [[1, "accommodation-preferences"], [1, "section-top"], [1, "section-header"], [1, "header-text"], [1, "edit-link"], ["data-automation", "AddAccommodationLink", 3, "click", 4, "ngIf"], ["data-automation", "EditAccommodationLink", 3, "click", 4, "ngIf"], ["class", "section-detail", 4, "ngIf"], ["class", "col-xs-12 noSidePadding currentPreferences", 4, "ngIf"], ["data-automation", "AddAccommodationLink", 3, "click"], ["data-automation", "EditAccommodationLink", 3, "click"], [1, "section-detail"], ["unsaved-changes-warning", "", "novalidate", "", "name", "accommodationPreferencesForm", "id", "accommodationPreferencesForm"], ["data-automation", "EditPreferredLocations", 4, "ngIf"], ["data-automation", "EditLeadPreferredUnitTypes"], [1, "col-xs-12", "noSidePadding", "margin-top-15"], ["for", "preferredUnitType", 1, "control-label"], [1, "col-xs-12", "noSidePadding"], ["name", "preferredUnitType", "data-automation", "preferredUnitType", "noDataAvailablePlaceholderText", "No unit types in facility", 3, "placeholder", "settings", "data", "initialSelectedItems", "onSelectionChange"], ["data-automation", "EditLeadPreferredUnits"], ["for", "preferredUnit", 1, "control-label"], ["name", "preferredUnit", "data-automation", "preferredUnit", "noDataAvailablePlaceholderText", "No units in facility", 3, "placeholder", "settings", "data", "initialSelectedItems", "onSelectionChange"], [1, "col-xs-12", "noSidePadding", "margin-top-15", "margin-bottom-15"], [1, "col-xs-4", "noSidePadding"], [1, "col-xs-4", "footer-left-button"], ["type", "reset", 1, "btn", "btn-warning", "btn-block", 3, "click"], [1, "col-xs-4", "noSidePadding", "footer-right-button"], ["type", "submit", 1, "btn", "btn-primary", "btn-block", 3, "click"], ["data-automation", "EditPreferredLocations"], ["for", "preferredLocation", 1, "control-label"], ["name", "preferredLocations", "data-automation", "preferredLocations", 3, "placeholder", "settings", "data", "initialSelectedItems", "onSelectionChange"], [1, "col-xs-12", "noSidePadding", "currentPreferences"], [1, "col-xs-1", "noSidePadding"], [1, "home-icon"], [1, "col-xs-11", "currentPreferenceValues"], ["data-automation", "LeadPreferredLocationsList"], ["data-automation", "LeadPreferredUnitTypesList"], ["data-automation", "LeadPreferredUnitsList"]], template: function AccommodationPreferencesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "span");
        i0.ɵɵtext(5, "Accommodation");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵtemplate(7, AccommodationPreferencesComponent_a_7_Template, 2, 0, "a", 5);
        i0.ɵɵtemplate(8, AccommodationPreferencesComponent_a_8_Template, 2, 0, "a", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(9, "hr");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, AccommodationPreferencesComponent_div_10_Template, 29, 21, "div", 7);
        i0.ɵɵtemplate(11, AccommodationPreferencesComponent_div_11_Template, 13, 9, "div", 8);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", !ctx.isReadOnly && !ctx.isExpanded && ctx.isAdd);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isReadOnly && !ctx.isExpanded && ctx.isEdit);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isExpanded);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isExpanded && ctx.isEdit);
    } }, directives: [i3.NgIf, i4.ɵangular_packages_forms_forms_y, i4.NgControlStatusGroup, i4.NgForm, i5.DnaRDropdownMultiSelect], pipes: [i3.AsyncPipe], styles: [".accommodation-preferences[_ngcontent-%COMP%]   .footer-left-button[_ngcontent-%COMP%] {\n  padding: 0px 5px 10px 0px;\n}\n.accommodation-preferences[_ngcontent-%COMP%]   .footer-right-button[_ngcontent-%COMP%] {\n  padding: 0px 0px 10px 5px;\n}\n.section-detail[_ngcontent-%COMP%] {\n  padding-top: 15px;\n}\n.noSidePadding[_ngcontent-%COMP%] {\n  padding-right: 0;\n  padding-left: 0;\n}\n.home-icon[_ngcontent-%COMP%] {\n  display: block;\n  width: 20px;\n  height: 20px;\n  background-image: url(../images/home-fill.svg);\n  background-repeat: no-repeat;\n  background-position: center;\n}\n.currentPreferences[_ngcontent-%COMP%] {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.currentPreferenceValues[_ngcontent-%COMP%] {\n  padding: 0 5px 10px 5px!important;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AccommodationPreferencesComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'accommodation-preferences',
                templateUrl: './accommodation-preferences.component.html',
                styleUrls: ['./accommodation-preferences.component.less']
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['authentication.service']
            }] }, { type: i1.AccommodationPreferencesService }, { type: i2.DnaRSnackBarService }]; }, { residencyId: [{
            type: core_1.Input
        }], isReadOnlyComponent: [{
            type: core_1.Input
        }], model: [{
            type: core_1.Input
        }] }); })();
